/**
 *  Struts-Spring-REFACTORED
 *    FROM --> ./legacy-web/src/main/assets/js/reservations/my-reservation.js
 *    TO   --> ./viewres-web/src/main/assets/js/viewres/my-reservation.js
 **/
AAcom('utilities', 'airportLookup', 'ajax', 'aaDatePicker', 'nearestAirportLookup', function (AAUI) {
    var dateRangeStartGetTime = 0;

    jQuery(document).ready(function () {
        AAUI.initAirportLookup(".aaAirportLookup");
        jQuery("#findReservationForm\\.originAirport").attr({
            placeholder: cityOrAirportPlaceholder
        });
        AAUI.initNearestAirportLookup(".current-location-btn");
        populatedateRangeStartGetTime();
        AAUI.initDatePicker(".aaDatePicker");
        AAUI.dateRangePicker('.aaRangeDatePicker');

        jQuery("#fromDate").datepicker({
            beforeShowDay: function (date) {
                return [
                    true, (((dateRangeStartGetTime == date.getTime())) ? "ui-state-highlight ui-state-active" : "")
                ];
            },
            beforeShow: function (input, inst) {},
            onSelect: function (dateText, inst) {
                try {
                    synchFromDateField();
                    populatedateRangeStartGetTime();
                } catch (ex) {}
            }
        }).datepicker("setDate", setDepartureDate(
          jQuery("#findReservationForm\\.departureMonth").val(),
          jQuery("#findReservationForm\\.departureDay").val(),
          jQuery('#departYear').val()
        ));

        jQuery("button.ui-datepicker-trigger").append("<span class='hidden-accessible'>" + calendarHiddenText + "</span>");
        if (jQuery("#fromDate").val() != "" && !isNaN(dateRangeStartGetTime)) {
            jQuery("#fromDate").datepicker("setDate", new Date(dateRangeStartGetTime));
        }
        if ((jQuery("#unsecure").val() == 'true') || (jQuery("#guest").val() == 'true')) {
            jQuery("#or-showForm").hide("fast");
            jQuery("#aa-myReservation .aa-search-form").animate({
                'height': 'toggle'
            });
            jQuery(".aa-search-modify").removeClass("aa-switch").addClass("aa-switch-open");
            if (typeof toggleHide != 'undefined') {
                jQuery(".aa-search-modify .hidden-accessible").text(toggleHide);
            }
        }

        jQuery(".aa-search-modify").on('click', function () {
            jQuery("#aa-myReservation .aa-search-form").animate({
                'height': 'toggle'
            });
            if (jQuery(this).hasClass('aa-switch')) {
                jQuery("#findReservationPage").show();
                jQuery(this).removeClass("aa-switch").addClass("aa-switch-open");
                jQuery(this).find("span.hidden-accessible").text(toggleHide);
                jQuery(this).find("span#findResToggle").attr("class", "icon-small icon-collapse");
            } else {
                jQuery("#findReservationPage").hide();
                jQuery(this).removeClass("aa-switch-open").addClass("aa-switch");
                jQuery(this).find("span#findResToggle").attr("class", "icon-small icon-expand");
                jQuery(this).find("span.hidden-accessible").text(toggleShow);
            }
            return false;
        });

        jQuery(document).ready(function () {
            jQuery(".aaAutoComplete").aaAirportAutoComplete();        
        });
    });

    function populatedateRangeStartGetTime() {
        var fromDate = new Date(jQuery("#fromDate").val());
        dateRangeStartGetTime = fromDate.getTime();
    }

    function synchFromDateField() {
        var date;
        date = jQuery("#fromDate").aaDateInput("getDate");
        jQuery("#findReservationForm\\.departureMonth").val(
            (date == null) ? "-1000" : date.getMonth() + 1);
        jQuery("#findReservationForm\\.departureDay").val(
            (date == null) ? "-1000" : date.getDate());
    }

    function setDepartureDate(paramMonth, paramDay, paramYear) {
        var date = new Date(paramYear, parseInt(paramMonth) - 1, paramDay);
        return date;
    }
});
